module.exports = __webpack_public_path__ + "static/img/map.85b839b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 12